export const PORTAL_CONTAINER_ID = "metabase-portal-root";
